/** In-memory cache for case Qarark suggest results (survives tab / step remounts). */

const cache = new Map();

export function suggestCacheKey({ caseId, title, description, practiceArea }) {
  if (caseId) return `case:${caseId}`;
  const t = (title || "").trim();
  const d = (description || "").trim();
  const area = practiceArea || "civil";
  return `create:${t}|${area}|${d}`;
}

export function getQararkSuggestCache(key) {
  if (!key) return null;
  return cache.get(key) || null;
}

export function setQararkSuggestCache(key, payload) {
  if (!key || !payload) return;
  cache.set(key, {
    connected: payload.connected ?? null,
    results: payload.results || [],
    suggestedQueries: payload.suggestedQueries || [],
    selected: payload.selected || {},
    roles: payload.roles || {},
  });
}

export function invalidateQararkSuggestCache(key) {
  if (key) cache.delete(key);
}

export function clearCreateQararkSuggestCaches() {
  for (const key of cache.keys()) {
    if (key.startsWith("create:")) cache.delete(key);
  }
}
